const PALETTE = [
  "bg-[#DBEAFE] text-[#1E5FEB]", "bg-emerald-100 text-emerald-700", "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700", "bg-violet-100 text-violet-700", "bg-cyan-100 text-cyan-700", "bg-slate-200 text-slate-700",
];

const hash = (s) => [...(s || "")].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);
const initials = (name) => (name || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

export function InitialsBadge({ name, size = 32, testId }) {
  return (
    <span data-testid={testId} title={name}
      className={`rounded-full flex items-center justify-center shrink-0 font-bold ring-2 ring-white ${PALETTE[hash(name) % PALETTE.length]}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}>
      {initials(name)}
    </span>
  );
}
